// Brazilian states for FCP
export const BRAZILIAN_STATES = [
  { value: '', label: 'Selecione um estado...' },
  { value: 'AC', label: 'Acre (AC)' },
  { value: 'AL', label: 'Alagoas (AL)' },
  { value: 'AM', label: 'Amazonas (AM)' },
  { value: 'AP', label: 'Amapá (AP)' },
  { value: 'BA', label: 'Bahia (BA)' },
  { value: 'CE', label: 'Ceará (CE)' },
  { value: 'DF', label: 'Distrito Federal (DF)' },
  { value: 'ES', label: 'Espírito Santo (ES)' },
  { value: 'GO', label: 'Goiás (GO)' },
  { value: 'MA', label: 'Maranhão (MA)' },
  { value: 'MT', label: 'Mato Grosso (MT)' },
  { value: 'MS', label: 'Mato Grosso do Sul (MS)' },
  { value: 'MG', label: 'Minas Gerais (MG)' },
  { value: 'PA', label: 'Pará (PA)' },
  { value: 'PB', label: 'Paraíba (PB)' },
  { value: 'PR', label: 'Paraná (PR)' },
  { value: 'PE', label: 'Pernambuco (PE)' },
  { value: 'PI', label: 'Piauí (PI)' },
  { value: 'RJ', label: 'Rio de Janeiro (RJ)' },
  { value: 'RN', label: 'Rio Grande do Norte (RN)' },
  { value: 'RS', label: 'Rio Grande do Sul (RS)' },
  { value: 'RO', label: 'Rondônia (RO)' },
  { value: 'RR', label: 'Roraima (RR)' },
  { value: 'SC', label: 'Santa Catarina (SC)' },
  { value: 'SP', label: 'São Paulo (SP)' },
  { value: 'SE', label: 'Sergipe (SE)' },
  { value: 'TO', label: 'Tocantins (TO)' }
]

// Constants for entry codes (fixed values)
export const ENTRADA_CONSTANTS = {
  COFINS_ST_ENTRADA: "98",
  PIS_ST_ENTRADA: "98", 
  IPI_ST_ENTRADA: "49"
}

// Options for Brazilian tax codes
export const IPI_ST_OPTIONS = [
  { value: '', label: 'Selecione...' },
  { value: '00', label: '00 - Entrada com Recuperação de Crédito' },
  { value: '01', label: '01 - Entrada Tributada com Alíquota Zero' },
  { value: '02', label: '02 - Entrada Isenta' },
  { value: '03', label: '03 - Entrada Não-Tributada' },
  { value: '04', label: '04 - Entrada Imune' },
  { value: '05', label: '05 - Entrada com Suspensão' },
  { value: '49', label: '49 - Outras Entradas' },
  { value: '50', label: '50 - Saída Tributada' },
  { value: '51', label: '51 - Saída Tributada com Alíquota Zero' },
  { value: '52', label: '52 - Saída Isenta' },
  { value: '53', label: '53 - Saída Não-Tributada' },
  { value: '54', label: '54 - Saída Imune' },
  { value: '55', label: '55 - Saída com Suspensão' },
  { value: '99', label: '99 - Outras Saídas' }
]

export const PIS_ST_OPTIONS = [
  { value: '', label: 'Selecione...' },
  { value: '01', label: '01 - Operação Tributável - Base de Cálculo = Valor da Operação' },
  { value: '02', label: '02 - Operação Tributável - Base de Cálculo = Valor da Operação (Alíquota Diferenciada)' },
  { value: '03', label: '03 - Operação Tributável - Base de Cálculo = Quantidade Vendida × Alíquota por Unidade' },
  { value: '04', label: '04 - Operação Tributável - Tributação Monofásica (Alíquota Zero)' },
  { value: '05', label: '05 - Operação Tributável - Substituição Tributária' },
  { value: '06', label: '06 - Operação Tributável - Alíquota Zero' },
  { value: '07', label: '07 - Operação Isenta da Contribuição' },
  { value: '08', label: '08 - Operação sem Incidência da Contribuição' },
  { value: '09', label: '09 - Operação com Suspensão da Contribuição' },
  { value: '49', label: '49 - Outras Operações de Saída' },
  { value: '50', label: '50 - Operação com Direito a Crédito - Vinculada Exclusivamente a Receita Tributada' },
  { value: '51', label: '51 - Operação com Direito a Crédito - Vinculada Exclusivamente a Receita Não-Tributada' },
  { value: '52', label: '52 - Operação com Direito a Crédito - Vinculada Exclusivamente a Receita de Exportação' },
  { value: '53', label: '53 - Operação com Direito a Crédito - Vinculada a Receitas Tributadas e Não-Tributadas' },
  { value: '54', label: '54 - Operação com Direito a Crédito - Vinculada a Receitas Tributadas no Mercado Interno e de Exportação' },
  { value: '55', label: '55 - Operação com Direito a Crédito - Vinculada a Receitas Não-Tributadas e de Exportação' },
  { value: '56', label: '56 - Operação com Direito a Crédito - Vinculada a Receitas Tributadas/Não-Tributadas e de Exportação' },
  { value: '60', label: '60 - Crédito Presumido - Operação de Aquisição Vinculada Exclusivamente a Receita Tributada' },
  { value: '61', label: '61 - Crédito Presumido - Operação de Aquisição Vinculada Exclusivamente a Receita Não-Tributada' },
  { value: '62', label: '62 - Crédito Presumido - Operação de Aquisição Vinculada Exclusivamente a Receita de Exportação' },
  { value: '63', label: '63 - Crédito Presumido - Operação de Aquisição Vinculada a Receitas Tributadas e Não-Tributadas' },
  { value: '64', label: '64 - Crédito Presumido - Operação de Aquisição Vinculada a Receitas Tributadas no Mercado Interno e de Exportação' },
  { value: '65', label: '65 - Crédito Presumido - Operação de Aquisição Vinculada a Receitas Não-Tributadas e de Exportação' },
  { value: '66', label: '66 - Crédito Presumido - Operação de Aquisição Vinculada a Receitas Tributadas/Não-Tributadas e de Exportação' },
  { value: '67', label: '67 - Crédito Presumido - Outras Operações' },
  { value: '70', label: '70 - Operação de Aquisição sem Direito a Crédito' },
  { value: '71', label: '71 - Operação de Aquisição com Isenção' },
  { value: '72', label: '72 - Operação de Aquisição com Suspensão' },
  { value: '73', label: '73 - Operação de Aquisição a Alíquota Zero' },
  { value: '74', label: '74 - Operação de Aquisição sem Incidência da Contribuição' },
  { value: '75', label: '75 - Operação de Aquisição por Substituição Tributária' },
  { value: '98', label: '98 - Outras Operações de Entrada' },
  { value: '99', label: '99 - Outras Operações' }
]

export const COFINS_ST_OPTIONS = [
  { value: '', label: 'Selecione...' },
  { value: '01', label: '01 - Operação Tributável - Base de Cálculo = Valor da Operação' },
  { value: '02', label: '02 - Operação Tributável - Base de Cálculo = Valor da Operação (Alíquota Diferenciada)' },
  { value: '03', label: '03 - Operação Tributável - Base de Cálculo = Quantidade Vendida × Alíquota por Unidade' },
  { value: '04', label: '04 - Operação Tributável - Tributação Monofásica (Alíquota Zero)' },
  { value: '05', label: '05 - Operação Tributável - Substituição Tributária' },
  { value: '06', label: '06 - Operação Tributável - Alíquota Zero' },
  { value: '07', label: '07 - Operação Isenta da Contribuição' },
  { value: '08', label: '08 - Operação sem Incidência da Contribuição' },
  { value: '09', label: '09 - Operação com Suspensão da Contribuição' },
  { value: '49', label: '49 - Outras Operações de Saída' },
  { value: '50', label: '50 - Operação com Direito a Crédito - Vinculada Exclusivamente a Receita Tributada' },
  { value: '51', label: '51 - Operação com Direito a Crédito - Vinculada Exclusivamente a Receita Não-Tributada' },
  { value: '52', label: '52 - Operação com Direito a Crédito - Vinculada Exclusivamente a Receita de Exportação' },
  { value: '53', label: '53 - Operação com Direito a Crédito - Vinculada a Receitas Tributadas e Não-Tributadas' },
  { value: '54', label: '54 - Operação com Direito a Crédito - Vinculada a Receitas Tributadas no Mercado Interno e de Exportação' },
  { value: '55', label: '55 - Operação com Direito a Crédito - Vinculada a Receitas Não-Tributadas e de Exportação' },
  { value: '56', label: '56 - Operação com Direito a Crédito - Vinculada a Receitas Tributadas/Não-Tributadas e de Exportação' },
  { value: '60', label: '60 - Crédito Presumido - Operação de Aquisição Vinculada Exclusivamente a Receita Tributada' },
  { value: '61', label: '61 - Crédito Presumido - Operação de Aquisição Vinculada Exclusivamente a Receita Não-Tributada' },
  { value: '62', label: '62 - Crédito Presumido - Operação de Aquisição Vinculada Exclusivamente a Receita de Exportação' },
  { value: '63', label: '63 - Crédito Presumido - Operação de Aquisição Vinculada a Receitas Tributadas e Não-Tributadas' },
  { value: '64', label: '64 - Crédito Presumido - Operação de Aquisição Vinculada a Receitas Tributadas no Mercado Interno e de Exportação' },
  { value: '65', label: '65 - Crédito Presumido - Operação de Aquisição Vinculada a Receitas Não-Tributadas e de Exportação' },
  { value: '66', label: '66 - Crédito Presumido - Operação de Aquisição Vinculada a Receitas Tributadas/Não-Tributadas e de Exportação' },
  { value: '67', label: '67 - Crédito Presumido - Outras Operações' },
  { value: '70', label: '70 - Operação de Aquisição sem Direito a Crédito' },
  { value: '71', label: '71 - Operação de Aquisição com Isenção' },
  { value: '72', label: '72 - Operação de Aquisição com Suspensão' },
  { value: '73', label: '73 - Operação de Aquisição a Alíquota Zero' },
  { value: '74', label: '74 - Operação de Aquisição sem Incidência da Contribuição' },
  { value: '75', label: '75 - Operação de Aquisição por Substituição Tributária' },
  { value: '98', label: '98 - Outras Operações de Entrada' },
  { value: '99', label: '99 - Outras Operações' }
]

export const ICMS_CST_OPTIONS = [
  { value: '', label: 'Selecione...' },
  { value: '00', label: '00 - Tributada Integralmente' },
  { value: '10', label: '10 - Tributada e com Cobrança do ICMS por Substituição Tributária' },
  { value: '20', label: '20 - Com Redução de Base de Cálculo' },
  { value: '30', label: '30 - Isenta ou Não Tributada e com Cobrança do ICMS por Substituição Tributária' },
  { value: '40', label: '40 - Isenta' },
  { value: '41', label: '41 - Não Tributada' },
  { value: '50', label: '50 - Suspensão' },
  { value: '51', label: '51 - Diferimento' },
  { value: '60', label: '60 - ICMS Cobrado Anteriormente por Substituição Tributária' },
  { value: '70', label: '70 - Com Redução de Base de Cálculo e Cobrança do ICMS por Substituição Tributária' },
  { value: '90', label: '90 - Outras' }
]

export const ORIGEM_OPTIONS = [
  { value: '0', label: '0 - Nacional, exceto as indicadas nos códigos 3, 4, 5 e 8' },
  { value: '1', label: '1 - Estrangeira - Importação direta, exceto a indicada no código 6' },
  { value: '2', label: '2 - Estrangeira - Adquirida no mercado interno, exceto a indicada no código 7' },
  { value: '3', label: '3 - Nacional, mercadoria ou bem com Conteúdo de Importação superior a 40% e inferior ou igual a 70%' },
  { value: '4', label: '4 - Nacional, cuja produção tenha sido feita em conformidade com os processos produtivos básicos' },
  { value: '5', label: '5 - Nacional, mercadoria ou bem com Conteúdo de Importação inferior ou igual a 40%' },
  { value: '6', label: '6 - Estrangeira - Importação direta, sem similar nacional, constante em lista da CAMEX e gás natural' },
  { value: '7', label: '7 - Estrangeira - Adquirida no mercado interno, sem similar nacional, constante lista CAMEX e gás natural' },
  { value: '8', label: '8 - Nacional, mercadoria ou bem com Conteúdo de Importação superior a 70%' }
]

// Constant for commercial unit (will not appear in the form)
export const UNIDADE_COMERCIAL = 'PC' 